const styles = (theme) => ({
  containerPaper: {
    width: "100%",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    padding: "11px",
    borderRadius: "16px",
    minWidth: "200px",
  },
  iconBlur: {
    position: "absolute",
    top: -40,
    left: -40,
    width: "100px",
    height: "100px",
    opacity: 0.2,
    color: theme.palette.white.main,
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  containerCircle: {
    position: "relative",
    display: "inline-flex",
  },
  circleDarker: {
    position: "absolute",
    left: 0,
    zIndex: 0,
  },
  circleLight: {
    zIndex: 1,
  },
  containerValuePercent: {
    top: "50%",
    left: "50%",
    position: "absolute",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
  },
  containerValueCard: { width: "100%", marginLeft: "20px" },
  titleValueCard: {
    fontWeight: "bold",
    fontSize: "23px",
    color: theme.palette.white.main,
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: "13px",
    opacity: 0.5,
    color: theme.palette.white.main,
  },

  titleValuePercent: {
    fontWeight: "bold",
    fontSize: "12px",
    color: theme.palette.white.main,
  },
  iconComponent: {
    position: "absolute",
    top: 5,
    right: 20,
    width: "60px",
    height: "60px",
    opacity: 0.2,
    color: theme.palette.white.main,
  },
});

export default styles;
